<template>
  <div>
    <draggable v-model="cards" :disabled="previewMode" @end="updateCardPositions">
      <div v-for="(card, index) in cards"
        :key="`schedule_card${index}`"
        class="row mb-3 pointer">
        <div class="col-10">
          <div class="card card-selectable" @click="addToCompleted(card)"
            :class="{ completed: cardFinished(card), 'bg-light': cardFinished(card) }">
            <div class="card-body">
              <svg viewBox="0 0 100 10" class="cross-off">
                <path d="M 1 5 h 0 0" />
              </svg>
              <div class="row align-items-center">
                <div class="col-2 text-center border-right">
                  <h1 class="display-3 m-0">{{ index + 1 }}</h1>
                </div>
                <div v-if="!hideImg" class="col">
                  <b-img :src="card.image" fluid class="vs-img" height="100" width="100" rounded></b-img>
                </div>
                <div v-if="!hideTitle" class="col-auto">
                  <h3 class="check-off-label text-center m-0">{{ card.title }}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-2 checked">
          <b-icon v-if="cardFinished(card)" icon="check2"></b-icon>
        </div>
      </div>
    </draggable>
    <div class="mt-3 non-share" v-if="completedCards.length">
      <b-button size="sm" variant="secondary" @click="restart">
        <b-icon icon="arrow-counterclockwise"></b-icon> Restart
      </b-button>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import {
  mapState, mapActions, mapMutations, mapGetters,
} from 'vuex';

export default {
  props: {
    previewMode: {
      type: Boolean,
      required: true,
    },
  },

  components: { draggable },

  data() {
    return {
      completedCards: [],
    };
  },

  watch: {
    completedCards() {
      this.updateVisualScheduleContent(true);
    },
  },

  computed: {
    ...mapState(['visualSchedule']),
    ...mapGetters(['hideTitle', 'hideImg']),

    cards: {
      get() {
        return this.visualSchedule.visual_schedule_cards_attributes;
      },
      set(val) {
        this.updateVisualSchedule({ field: 'visual_schedule_cards_attributes', value: val });
      },
    },

    displayId() {
      return this.visualSchedule.visual_schedule_display_id;
    },
  },

  methods: {
    ...mapActions(['updateCardPositions']),
    ...mapMutations(['updateVisualSchedule', 'updateVisualScheduleContent']),

    addToCompleted(card) {
      if (this.cardFinished(card)) {
        this.removeFromCompleted(card);
        return;
      }
      this.completedCards.push(card);
    },

    removeFromCompleted(card) {
      const index = this.completedCards.findIndex((c) => c.card_id === card.card_id);
      if (index !== -1) this.completedCards.splice(index, 1);
    },

    cardFinished(card) {
      return this.completedCards.find((c) => c.card_id === card.card_id && card.position === c.position);
    },

    restart() {
      this.completedCards = [];
    },
  },
};
</script>
